import rootReducer from "./reducers";

export function getProjectListModule() {
  return {
    id: "project-list",
    reducerMap: {
      projectList: rootReducer
    }
  };
}
